import { setTabConfigApi, setWindowDomainByTabIdApi } from '@core/core/api'
import { updateTabDomain, useAppDispatch } from '@core/core/store'
import type { WorkAreaId } from '@core/core/types'
import type { ChannelMessage } from 'common/messenger'
import type { Nullable, ProjectId, TabId } from 'common/types'

export const useUpdateTabDomain = (
  projectId: ProjectId,
  activeWorkAreaId: Nullable<WorkAreaId>,
  tabId?: TabId,
) => {
  const dispatch = useAppDispatch()

  async function updateActiveTabDomain({ payload: domainType }: ChannelMessage<'updateTabDomain'>) {
    if (tabId && activeWorkAreaId) {
      await setTabConfigApi(projectId, tabId, domainType)

      if (domainType !== 'ANY') {
        await setWindowDomainByTabIdApi(projectId, tabId, domainType)
      }

      dispatch(updateTabDomain(activeWorkAreaId, tabId, domainType))
    }
  }

  return { updateActiveTabDomain }
}
